import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useState } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { OnboardingData, OnboardingRoutes } from '../..';
import { t } from '../../../../../types/translation/Translator';
import { Button } from '../../../../components/Button';
import { ButtonVariant } from '../../../../components/Button/Button';
import { OnboardingStep, OnboardingTitle } from '../../components';
import OnboardingPaneHeader from '../../components/OnboardingPaneHeader';
import StockLocationForm from './components/StockLocationForm';
import { StockLocationInput } from '../../../../../types/stock_location/stockLocation.input';

interface OnboardingEditStockLocationPaneProps {
  data: OnboardingData;
  onSave: (stockLocation: StockLocationInput) => void;
}

export default function OnboardingStockLocationEditPane({ data, onSave }: OnboardingEditStockLocationPaneProps) {
  const navigate = useNavigate();

  const id = useParams()['id'] || '';

  const found = [...data.summary.stockLocations.values()].find(sl => sl.id === id);
  if (!found) return <Navigate to={OnboardingRoutes.stockLocationOverview} replace />;

  const [stockLocation, setStockLocation] = useState(new StockLocationInput(found));

  return (
    <div className='grid gap-4'>
      <OnboardingPaneHeader back={() => navigate(-1)} />
      <div className='grid gap-1'>
        <OnboardingStep />
        <OnboardingTitle text={'Edit your Stock Location'} />
      </div>

      <StockLocationForm
        existing={data.summary.stockLocations}
        stockLocation={stockLocation}
        setStockLocation={setStockLocation}
      />

      <div className='flex gap-2'>
        <Button
          text={t(TranslationKey.save).singular.label}
          onClick={() => {
            onSave(stockLocation);
            navigate(OnboardingRoutes.stockLocationOverview);
          }}
          disabled={(() => {
            if (!stockLocation.name) return true;
            const withExistingName = [...data.summary.stockLocations.values()].find(
              sl => sl.name === stockLocation.name && sl.id !== stockLocation.id,
            );
            if (withExistingName) return true;
            return false;
          })()}
        />
        <Button
          variant={ButtonVariant.linkPrimary}
          text={t(TranslationKey.cancel).singular.label}
          onClick={() => navigate(OnboardingRoutes.stockLocationOverview)}
        />
      </div>
    </div>
  );
}
